import { DEFAULT_ROLE_PERMISSIONS, type RolePermissionMap } from '../../utils/rolePermissions';

export const backfillNewMenus = (permissions: RolePermissionMap): RolePermissionMap => {
  const updated: RolePermissionMap = { ...permissions };

  // Hanya tambah id yang BENAR-BENAR BARU (belum ada di role mana pun) — revoke
  // via checklist TIDAK boleh hidup lagi. Dulu: union per-role → revoke sia-sia.
  const knownMenus = new Set<string>();
  const knownFeatures = new Set<string>();
  Object.values(updated).forEach((p: any) => {
    (p?.menus || []).forEach((m: string) => knownMenus.add(m));
    (p?.features || []).forEach((f: string) => knownFeatures.add(f));
  });

  Object.entries(DEFAULT_ROLE_PERMISSIONS).forEach(([role, defaults]) => {
    const current = updated[role] ?? defaults;
    const currentMenus = new Set(current.menus || []);
    const currentFeatures = new Set(current.features || []);

    defaults.menus.forEach((menuId) => { if (!knownMenus.has(menuId)) currentMenus.add(menuId); });
    defaults.features.forEach((featureId) => { if (!knownFeatures.has(featureId)) currentFeatures.add(featureId); });

    updated[role] = {
      menus: Array.from(currentMenus),
      features: Array.from(currentFeatures)
    };
  });

  return updated;
};
